export default __webpack_public_path__ + "static/media/lic.f98eccaa.png";